module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/311.6b0324eb.png";